//
// Scroll To anchor (smooth)
//
document.addEventListener('DOMContentLoaded', function () {
	
	let menu = document.querySelector('.site-header');
	let menuH = menu.offsetHeight;
	
	let linksSousMenu = document.querySelectorAll('.brikx-sousmenu-ancre a');
	linksSousMenu.forEach(function (el) {
		el.addEventListener( 'click', function( event ) {
			event.preventDefault();
			event.stopPropagation();
			console.log(el);
			let url = el.getAttribute('href'); 
			let target = url.split('#')[1];
			console.log(target);
			scrollToAnchorSmoother(target, false); // lorsque le pa
		}, false );
	})

	function scrollToAnchor (target) {
		target.scrollIntoView({
			block: 'start',
			behavior: 'smooth',
			inline: 'nearest'
		})
	}

	function scrollToAnchorSmoother (target, isSmooth = true) {
		let el = document.querySelector('#' + target);
		// console.log(el);
		let positionTop = (getOffset(el).top - menuH);
		// console.log(positionTop);
		let behaviorValue = (isSmooth) ? 'smooth' : 'auto';
		requestAnimationFrame(function() {
			window.scroll({ top: positionTop, left: 0, behavior: behaviorValue });
		})

		// Bug 
		// HB : quand behavior === 'smooth' window.scroll ne va pas jusqu'a la target... mais il s'arrete avant
	}

	//
	// Au chargement de la page si une ancre est précisé on scroll jusqu'a celle-ci
	//
	let url = document.location.toString();
	if (url.match('#')) {
		let target = url.split('#')[1];
		console.log(target);
		scrollToAnchorSmoother(target, false)
	}
})